<template>
  <div>
    <div class="info">
      <div class="text">
        <div class="orange f22 m-b-20">
          暂未开通店铺
        </div>
        <div class="wrap desc">
          入住商户可自定义店铺设计，植入企业个性化名片和产品展示，一键生成报价，传播更方便。
        </div>
        <div
          class="btn"
          @click="toOpen"
        >
          开通店铺
        </div>
      </div>
      <div class="func">
        <el-card
          v-for="item in funcList"
          :key="item.name"
          class="func-info"
        >
          <img
            class="m-t-40"
            :src="item.img"
          >
          <div class="m-t-40">
            {{ item.name }}
          </div>
          <div class="m-t-20 desc">
            {{ item.desc }}
          </div>
        </el-card>
      </div>
    </div>
    <open-store
      v-if="openStoreVisible"
      :opt-type="'open'"
      :open-store-visible="openStoreVisible"
      @close="openStoreVisible=false"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import OpenStore from './open-store'
import jyImg from '@/assets/store_Icon_jy.png'
import kqImg from '@/assets/store_Icon_kq.png'
import yxImg from '@/assets/store_Icon_yx.png'
export default {
  name: 'NoStore',
  components: {
    OpenStore
  },
  data () {
    return {
      openStoreVisible: false,
      funcList: [
        { img: kqImg, name: '拓展客群', desc: '面向上万家贸易商+终端客户，获得更多新客，扩大交易机会。' },
        { img: jyImg, name: '自主交易', desc: '买卖双方自主成交，没有中间商赚差价。' },
        { img: yxImg, name: '精准营销', desc: '为入驻商家提供在线化客户管理营销工具，通过线上线下立体式触达客户，精准营销，提高客户复购' },
      ]
    }
  },
  methods: {
    toOpen () {
      const userInfo = this.$store.state.user.info
      if (userInfo.marketId !== '10606') {
        this.$message.warning('非优选(KA)市场不能开店')
        return
      }

      this.openStoreVisible = true
    }
  }

}
</script>

<style lang="scss" scoped>
.info {
  background: url('~@/assets/store_Icon_bg.png') no-repeat;
  background-size: cover;
  .orange {
    color:#ff5f00;
  }
  .text {
    padding: 10% 15%;
  }
  .wrap {
    width: 240px;
    word-wrap: break-word;
    line-height: 24px;
  }
  .btn {
    width: 160px;
    text-align: center;
    padding: 10px 0;
    background-color: #ff5f00;
    border-radius: 4px;
    margin-top: 50px;
    cursor: pointer;
  }
  .func {
    display: flex;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    &-info {
      width: 25%;
      height: 400px;
    }
    .desc {
      margin: 0 auto;
      text-align: left;
      line-height: 24px;
    }
  }

}
</style>
